module.exports = __webpack_public_path__ + "img/add-first-timer.5f455c3c.svg";